<div class="scrollvarsel" data-testid="scrollvarsel"><span>{{'Scroll ned for å se resten av skjemaet...' | translate}}</span></div>
<ng-content/>
  
